import React, { useState, useEffect } from 'react'
import { Empty, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { category, tag, products } from "../../../utils/schemas"
import CategoriesCard from '../../../components/categories-card/'
import '../style.css'
import BackButton from '../../../components/back-button';

import ApiServices from "../../../utils/apiServices"
import Loading from '../../../components/loading';
import { useParams } from 'react-router-dom';
import ProductCard from '../../../components/product-card';

const styles = {
  container: {
    position: "relative",
    zIndex: 1,
    width: '100%',
    margin: '0 auto',
  },
  icon: {
    position: "absolute",
    top: '60%',
    right: '20px',
    fontSize: '24px',
    color: '#fd0088',
    transform: 'translateY(-50%)',
    zIndex: 1,
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '30px',
    border: '3px solid #fd0088',
    fontSize: '16px',
    marginTop: '16px',
  },
};
export default function Tags() {
  const { getList, getById } = ApiServices()
  const params = useParams()

  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingTags, setIsLoadingTags] = useState(true)
  const [isLoadingProduct, setIsLoadingProduct] = useState(true)

  const [tagSelected, setTagSelected] = useState(null)

  const [categoryData, setCategoryData] = useState(null)
  const [tagList, setTagList] = useState([])
  const [productList, setProductList] = useState([])

  const [isSearch, setIsSearch] = useState(false)
  const [searchData, setSearchData] = useState(false)
  const [searchValue, setSearchValue] = useState(null)

  useEffect(() => {
    if (params.category_id)
      getCategory(params.category_id)
  }, [])

  function getCategory(category_id) {
    setIsLoading(true)
    getById(category, category_id).then((response) => {
      setCategoryData(response.data)

      getTags(category_id)
      setTimeout(() => {
        setIsLoading(false)
      }, 500);

    }).catch((err) => {
      setCategoryData(null)
    })
  }

  function getTags(category_id) {
    getList(tag, { category_id: category_id }).then((response) => {
      setTagList(response.data)
      getProducts(category_id)
      setTimeout(() => {
        setIsLoadingTags(false)
      }, 500);
    }).catch((err) => {
      setTagList([])
    })
  }

  function getProducts(category_id, tag_id = null) {
    setIsLoadingProduct(true)
    getList(products, { category_id: category_id, tag_id: tag_id }).then((response) => {

      setTimeout(() => {
        setIsLoadingProduct(false)
        setIsSearch(false)
        setIsLoading(false)
      }, tag_id ? 500 : 1000);
      setProductList(response.data)
    }).catch((err) => {
      console.log('err :>> ', err);
    })
  }

  function onClickSelectTag(data) {
    setProductList([])
    setTagSelected(data)
    getProducts(data.category_id, data.id)

    setSearchData(null)
    setIsSearch(null)
    setSearchValue(null)
  }

  function onSearchProducts() {
    setIsLoading(true)
    setTagSelected(null)
    setIsLoadingProduct(true)
    const getParams = {
      page: 1,
      search: searchValue ?? null,
      category_id: params.category_id ?? null,
    }

    if (!searchValue || searchValue === "") {
      setIsSearch(false)
      setSearchData([])



      getProducts(getParams.category_id)

    } else {
      getList(products, getParams).then((response) => {
        if (response.code === 200) {
          setIsSearch(true)
          setSearchData(response.data)
          setTimeout(() => {
            setIsLoading(false)
            setIsLoadingProduct(false)
          }, 500);
        }
      }).catch((err) => {
        console.log('err :>> ', err);
      })
    }
  }



  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
        <BackButton />
      </div>
      <div style={styles.container}>
        <SearchOutlined style={styles.icon} onClick={() => onSearchProducts()} />
        <Input
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onPressEnter={onSearchProducts}
          type="text"
          placeholder={`ค้นหาสินค้าในหมวด '${categoryData?.name}'`}
          style={styles.input}
        />
      </div>
      {categoryData && <h1 style={{ fontSize: "clamp(24px, 5vw, 32px)" }}>{categoryData?.name}</h1>}
      <div>
        <div className='categories-container'>
          {!isLoadingTags && tagList?.length > 0 ? tagList?.map((tag) => {
            return <CategoriesCard isSelected={tagSelected && tag.id === tagSelected.id} data={tag} onClick={onClickSelectTag} navigate_to={tag.id} name={tag.name} image={tag?.images[0]} />
          }) : !isLoadingTags && <Empty description="ไม่พบรายการหมวดหมู่สินค้า" />}
        </div>
      </div>
      {isSearch ? <>
        <h1 style={{ fontSize: "clamp(24px, 5vw, 32px)" }}>รายการสินค้าที่ค้นหา</h1>
        {!isLoadingProduct && <div className='categories-container'>
          {searchData?.length > 0 ? searchData?.map((product) => {
            return <ProductCard navigate_to={`/products/${product.category_id}/${product.tag_id}/${product.id}`} name={product.name} image={product?.images[0]} description={product.detail} />
          }) : <Empty description="ไม่พบรายการสินค้า" />}
        </div>}
      </> :
        <div className='all-product-container'>
        
          {!isLoadingTags && tagList?.length > 0 && <div style={{ borderTop: "4px solid #FD0097", padding: "20px 0px 40px 0px" }}>
            {categoryData && <h1 style={{ fontSize: "clamp(24px, 5vw, 32px)" }}>รายการสินค้า{tagSelected ? ` (${tagSelected.name})` : "ทั้งหมด"}</h1>}
            {!isLoadingProduct && <div className='categories-container'>
              {productList?.length > 0 ? productList?.map((product) => {
                return <ProductCard navigate_to={`/products/${product.category_id}/${product.tag_id}/${product.id}`} name={product.name} image={product?.images[0]} description={product.detail} />
              }) : <Empty description="ไม่พบรายการสินค้า" />}
            </div>}
          </div>}
        </div>


        }

      {isLoading || isLoadingTags || isLoadingProduct ? <Loading description={isLoading ? "กำลังโหลดหมวดหมู่สินค้า" : isLoadingTags ? "กำลังโหลดหมวดหมู่สินค้า" : isLoadingProduct ? "กำลังโหลดสินค้า" : "กำลังโหลดข้อมูล"} /> : <React.Fragment />}
    </div>

  )
}
